(function () {
  var bar = null;
  var sentinel = null;
  var placeholder = null;
  var observer = null;
  var headerObserver = null;
  var isStuck = false;

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function getHeader() {
    return document.querySelector('header-component, .header-section');
  }

  function getHeaderHeight() {
    var header = getHeader();
    return header ? header.offsetHeight : 0;
  }

  function measurePlaceholder() {
    if (!bar || !placeholder) return;
    if (!isStuck) {
      placeholder.style.height = bar.offsetHeight + 'px';
    }
  }

  function applyStuckState(stuck) {
    // Read first, write second — avoids read-after-write layout
    // thrashing in the same tick.
    var headerHeight = stuck ? getHeaderHeight() : null;

    isStuck = stuck;
    bar.classList.toggle('is-stuck', stuck);
    placeholder.classList.toggle('is-active', stuck);
    bar.style.top = stuck ? headerHeight + 'px' : '';
  }

  function teardown() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (headerObserver) {
      headerObserver.disconnect();
      headerObserver = null;
    }
    if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
    if (bar) {
      bar.classList.remove('is-stuck');
      bar.style.top = '';
    }
    bar = sentinel = placeholder = null;
    isStuck = false;
  }

  function isEligible(el) {
    // The mobile filter drawer also carries .facets-block-wrapper. Making it
    // sticky turns it into a full-width fixed layer over the page that
    // swallows every click, including the header menu. Never pick it, and
    // never pick a bar with no rendered height for the same reason.
    if (el.id === 'filters-drawer') return false;
    if (el.closest('theme-drawer, dialog')) return false;
    if (!isVisible(el)) return false;
    if (el.getBoundingClientRect().height < 8) return false;
    return true;
  }

  function setup() {
    var found = null;
    document.querySelectorAll('.facets-block-wrapper').forEach(function (el) {
      if (!found && isEligible(el)) found = el;
    });

    if (!found) {
      teardown();
      return;
    }
    if (found === bar) {
      measurePlaceholder();
      return;
    }

    teardown();
    bar = found;

    sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:0;pointer-events:none;';
    bar.parentNode.insertBefore(sentinel, bar);

    placeholder = document.createElement('div');
    placeholder.className = 'facets-placeholder';
    bar.parentNode.insertBefore(placeholder, bar);

    measurePlaceholder();

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          applyStuckState(!entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);

    // Keep the bar's top offset correct if the header's own height
    // changes (e.g. its hide-on-scroll animation) while the bar is
    // already stuck — this is what was going stale before.
    var header = getHeader();
    if (header) {
      headerObserver = new MutationObserver(function () {
        if (isStuck) {
          bar.style.top = getHeaderHeight() + 'px';
        }
      });
      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ['data-sticky-state'],
      });
    }
  }

  setup();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setup, 200);
  });
})();
